import axios from 'axios'

const url = process.env.VUE_APP_HOST;

const getCal = async function (page = 1, itemsPerPage = 0, sortBy = "", sortDesc = "" ,searchTerm = ""){
    if (sortBy=='Code')
        sortBy = 'HostKey';
    let _url = url + 'api/Calendar?page='+page+'&itemsPerPage='+itemsPerPage

    if (searchTerm) _url = _url + '&searchItem='+searchTerm
    
    var asc = !Boolean(sortDesc[0]);

    if (sortBy!="")
       _url = _url +'&sortBy='+sortBy+'&asc='+asc
    
    let access_token = "";
    
    let auth = localStorage.getItem('scientia-session-authorization');

    if (!auth)
    {

    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }
    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`,
           'Content-Type': 'application/json'
        }
    };
    let result = await axios.get(_url, headers)

    return result.data;
}

const getMyCal = async function (){

    let _url = url + 'api/Calendar/me'
    
    let access_token = "";
    
    let auth = localStorage.getItem('scientia-session-authorization');

    if (!auth)
    {

    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }
    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`,
           'Content-Type': 'application/json'
        }
    };
    let result = await axios.get(_url, headers)

    return result.data;
}

const subscribeCal = async function (calId, userId){

    let _url = url + 'api/Calendar/'+calId+'/users/'+userId+'/ics'
    
    let access_token = "";
    
    let auth = localStorage.getItem('scientia-session-authorization');

    if (!auth)
    {

    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }
    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`,
           'Content-Type': 'application/json'
        }
    };
    let result = await axios.get(_url, headers)

    return result.data;
}


const createCal = async function (payload){

    let _url = url + 'api/Calendar';
    
    let access_token = "";
    
    let auth = localStorage.getItem('scientia-session-authorization');

    if (!auth)
    {

    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }
    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`,
           'Content-Type': 'application/json'
        }
    };
    let result = await axios.post(_url, JSON.stringify(payload) ,headers)

    return result.data;
}

const updateCal = async function (payload){

    let _url = url + 'api/Calendar/' + payload.identity;
    
    let access_token = "";
    
    let auth = localStorage.getItem('scientia-session-authorization');

    if (!auth)
    {

    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }
    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`,
           'Content-Type': 'application/json'
        }
    };
    let result = await axios.put(_url, JSON.stringify(payload) ,headers)

    return result.data;
}

const delCal = async function (id){

    let _url = url + 'api/Calendar/' + id;
    
    let access_token = "";
    
    let auth = localStorage.getItem('scientia-session-authorization');

    if (!auth)
    {

    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }
    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`,
           'Content-Type': 'application/json'
        }
    };
    let result = await axios.delete(_url, headers)

    return result.data;
}

const getTarget = async function (id){

    let _url = url + 'api/Calendar/' + id+'/TargetInfo';
    
    let access_token = "";
    
    let auth = localStorage.getItem('scientia-session-authorization');

    if (!auth)
    {

    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }
    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`,
           'Content-Type': 'application/json'
        }
    };
    let result = await axios.get(_url, headers)

    return result.data;
}

const createTarget = async function (payload){

    let _url = url + 'api/Calendar/' + payload.calendarId+'/TargetInfo';
    
    let access_token = "";
    
    let auth = localStorage.getItem('scientia-session-authorization');

    if (!auth)
    {

    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }
    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`,
           'Content-Type': 'application/json'
        }
    };
    let result = await axios.post(_url, JSON.stringify(payload) ,headers)

    return result.data;
}

const updateTarget = async function (payload){

    let _url = url + 'api/Calendar/' + payload.calendarId+'/TargetInfo/'+payload.identity;
    
    let access_token = "";
    
    let auth = localStorage.getItem('scientia-session-authorization');

    if (!auth)
    {

    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }
    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`,
           'Content-Type': 'application/json'
        }
    };
    let result = await axios.put(_url, JSON.stringify(payload) ,headers)

    return result.data;
}

const delTarget = async function (payload){

    let _url = url + 'api/Calendar/' + payload.calendarId+'/TargetInfo/'+payload.identity;
    
    let access_token = "";
    
    let auth = localStorage.getItem('scientia-session-authorization');

    if (!auth)
    {

    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }
    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`,
           'Content-Type': 'application/json'
        }
    };
    let result = await axios.delete(_url, headers)

    return result.data;
}

const uploadFile = async function (type, payload, param) {
    let auth = localStorage.getItem('scientia-session-authorization');

    let access_token = "";

    if (!auth)
    {
        access_token = process.env.VUE_APP_TOKEN;
    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }

    let _url = url + 'api/Calendar/Upload/'+ type

    if (param) _url = _url + '?param=' + param;

    let headers = {
        headers: {
            'Authorization': `Bearer ${access_token}`,
           // 'Content-Type': 'multipart/form-data'
        }
    };
    let result = await axios.post(_url, payload.file, headers)

    if (result.status==200)
        return result.data;
    else
        return "ERROR"
}

const createCustomCal = async function (id, payload){

    let _url = url + 'api/Calendar/custom/users/'+id;
    
    let access_token = "";
    
    let auth = localStorage.getItem('scientia-session-authorization');

    if (!auth)
    {

    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }
    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`,
           'Content-Type': 'application/json'
        }
    };
    let result = await axios.post(_url, JSON.stringify(payload) ,headers)
  
    return result.data;
}

const subscribeCustomCal = async function (calId, userId){

    let _url = url + 'api/Calendar/custom/'+calId+'/users/'+userId+'/ics'
    
    let access_token = "";
    
    let auth = localStorage.getItem('scientia-session-authorization');

    if (!auth)
    {

    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }
    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`,
           'Content-Type': 'application/json'
        }
    };
    let result = await axios.get(_url, headers)

    return result.data;
}

const generateExcel = async function (payload, type = "XLS"){

    let _url = url + 'api/Calendar/Generate';

    if (type == 'Excel')
        type = 'XLS'
    
    _url = _url + '?type=' + type;

    let access_token = "";
    
    let auth = localStorage.getItem('scientia-session-authorization');

    if (!auth)
    {

    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }
    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`,
           'Content-Type': 'application/json'
        }
    };
    let result = await axios.post(_url, JSON.stringify(payload) ,headers)
    return result.data;
}

const downloadCSV = async function (id){

    let _url = url + 'api/Calendar/'+id+'/download';
    
    let access_token = "";
    
    let auth = localStorage.getItem('scientia-session-authorization');

    if (!auth)
    {

    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }
    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`,
           'Content-Type': 'application/json'
        }
    };
    let result = await axios.get(_url, headers)
    return result.data;
}


const downloadExcel = async function (id){

    let _url = url + 'api/Calendar/download/'+id;
    
    let access_token = "";
    
    let auth = localStorage.getItem('scientia-session-authorization');

    if (!auth)
    {

    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }
    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`,
           'Content-Type': 'application/json'
        }
    };
    let result = await axios.get(_url, headers)
    return result.data;
}


const pubCal = async function (id, flag){

    let _url = url + 'api/Calendar/'+id+'/publish?flag='+flag;
    
    let access_token = "";
    
    let auth = localStorage.getItem('scientia-session-authorization');

    if (!auth)
    {

    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }
    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`,
           'Content-Type': 'application/json'
        }
    };
    let result = await axios.post(_url,'', headers)
    return result.data;
}

export const calService = { getCal, createCal, updateCal, delCal, getTarget, createTarget, updateTarget, 
    delTarget, uploadFile, getMyCal, subscribeCal, createCustomCal, subscribeCustomCal, generateExcel, downloadExcel, pubCal, downloadCSV}